import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFoundPage: React.FC = () => {
  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgGradient="linear(to-br, gray.200, gray.400)"
      p={4}
      textAlign="center"
    >
      <Helmet>
        <title>Oldal nem található - Wobble</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <VStack
        spacing={6}
        maxW="md"
        mx="auto"
        p={6}
        bg="white"
        rounded="lg"
        shadow="lg"
      >
        <Text fontSize={{ base: "4xl", md: "6xl" }} fontWeight="bold" color="teal.600">
          404
        </Text>
        <Heading as="h1" fontSize={{ base: "2xl", md: "3xl" }}>
          Oldal nem található
        </Heading>
        <Text fontSize={{ base: "md", md: "lg" }} color="gray.600">
          Sajnos, a keresett oldal nem létezik vagy eltávolították.
        </Text>
        <Button
          as={RouterLink}
          to="/"
          colorScheme="teal"
          rel="noopener noreferrer"
          size="md"
          rounded="md"
          _hover={{
            bg: "teal.500",
            color: "white",
            transform: "scale(1.05)",
            textDecoration: "none",
            rel: "noopener noreferrer",
          }}
        >
          Vissza a főoldalra
        </Button>
      </VStack>
    </Box>
  );
};

export default NotFoundPage;
